<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="sort",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.sort"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_teacher') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="teachers",
                :show-labels="false",
                label="fullName",
                track-by="id",
                :searchable="true",
                :loading="loadingTeachers",
                :placeholder="teachersPlaceholder",
                v-model="form.teacher",
                :disabled="isTeacherDisabled",
                @open="getTeachers"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_teacherNotFound') }}
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element.fields__element--search-neighbour
            label.fields__label {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_gradePlaceholder')",
                v-model="form.name"
                @search="sendForm"
            )
        .fields__element
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../../utils/searchFieldsMixin';
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore';
    import statusFieldMixin from '../utils/statusFieldMixin';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        props: ['schoolId'],
        data() {
            return {
                schools: [],
                teachers: [],
                sort: [
                    {label: this.$i18n.t('fields.list_sortName'), by: 'name'},
                    {label: this.$i18n.t('fields.list_sortLocation'), by: 'location'}
                ],
                form: {
                    school: null,
                    teacher: null,
                    sort: null,
                    name: null,
                    status: 'active'
                }
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        school: null,
                        teacher: null,
                        sort: null,
                        name: null,
                        status: 'active'
                    };
                }
            },
            'form.school' () {
                this.updateList()
            },
            'form.teacher'() {
                this.updateList()
            },
            'form.sort'() {
                this.updateList()
            },
            'form.name'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
        },
        methods: {
            sendForm() {
                this.$emit(
                        'search',
                        Object.assign({}, this.form, {
                            sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                        })
                );
            },
            resetResults() {
                this.user.isSuperadmin && (this.form.school = null);
                this.form.teacher = null;
                this.form.sort = null;
                this.form.name = null;
                this.form.status = 'active';
                this.$emit('search', Object.assign({}, this.form, {status: 'active'}));
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
